import axios from "axios";
import Vue from "vue";

// Global configuration
const instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    withCredentials: true
});

instance.defaults.headers.common["Accept"] = "application/json";
instance.defaults.headers.post["Content-Type"] = "application/json";
instance.defaults.headers.put["Content-Type"] = "application/json";
instance.defaults.headers.delete["Content-Type"] = "application/json";

// Global helpers
Vue.prototype.$http = instance;

export default instance;